import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 550) {
  const check = () => window.innerWidth <= breakpoint || window.innerWidth <= window.innerHeight / 2;
  const [isMobile, setIsMobile] = useState(check);
  useEffect(() => {
    const h = () => setIsMobile(check());
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return isMobile;
}
